/**
 * 任意の値を安全に Date に変換する。
 * - Date インスタンス → 有効なら返す、Invalid Date なら null
 * - string / number → new Date() で変換、Invalid Date なら null
 * - その他 / null / undefined → null
 *
 * 2026-05-14: src/components/spreadsheet/SpreadsheetGrid.tsx 内の同名関数から統合。
 * 同じパターンが必要な箇所はここを使う。
 */
export function safeDate(d: unknown): Date | null {
  if (!d) return null
  if (d instanceof Date) {
    if (isNaN(d.getTime())) return null
    return d
  }
  if (typeof d === 'string' || typeof d === 'number') {
    const parsed = new Date(d)
    if (isNaN(parsed.getTime())) return null
    return parsed
  }
  return null
}

// 日付範囲から日付配列を生成
export function generateDateRange(start: string, end: string): Date[] {
  if (!start || !end) return []
  const current = new Date(start)
  const endDate = new Date(end)
  if (isNaN(current.getTime()) || isNaN(endDate.getTime())) return []

  const dates: Date[] = []
  // 安全策: 最大400日まで
  let safety = 0
  while (current <= endDate && safety < 400) {
    dates.push(new Date(current))
    current.setDate(current.getDate() + 1)
    safety++
  }

  return dates
}

// 月ごとにグループ化
export function groupByMonth(dates: Date[]): Map<string, Date[]> {
  const groups = new Map<string, Date[]>()
  for (const date of dates) {
    const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
    if (!groups.has(key)) groups.set(key, [])
    groups.get(key)!.push(date)
  }
  return groups
}

// 今日のISO文字列
export function today(): string {
  const d = new Date()
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

// N日前のISO文字列
export function daysAgo(n: number): string {
  const d = new Date()
  d.setDate(d.getDate() - n)
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}
